import { TimelineStep } from '@websky/graphql';
import { GdsAggregationServiceType } from '../../../../../Checkout/types';

export function getAggregatorGroupType(type: GdsAggregationServiceType, timelineStep?: TimelineStep): string {
	return timelineStep ? `${type}/${timelineStep}` : type;
}
